import { controls } from "../controls";

const tr306 = {
  label: "Scroll",
  starting: true,
  url: "tr306",
  pageLabel: "Share Demand Posting",
  pageType: "history",
  filter: [
    ...controls.displayText({ label: "Region", width: "col-sm-2" }),
    ...controls.Region(),
    {
      inputType: "showdata",
      tab: "Modal",
      data: "region",
      textcolor: "black",
      name: "region_display",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },

    ...controls.displayText({ label: "Branch", width: "col-sm-2" }),
    ...controls.branch({ defaultValue: "assigned_branch", isReadOnly: true, isRequired: true, star: true }),
    ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-4" }),

    ...controls.displayText({ tab: "filter", width: "col-sm-4" }),

    ...controls.magicDateLabel({ tab: "filter", label: "From-To Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "from_date", width: "col-sm-2", default: "30660000000 ago" }),

    ...controls.magicDateLabel({ tab: "filter", label: "-", width: "col-sm-0" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "to_date", width: "col-sm-2", default: "n" }),

    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),

    ...controls.magicDateLabel({ tab: "filter", label: "As On Date", width: "col-sm-2" }),
    ...controls.magicDate({ isReadOnly: true, name: "up_to_date", default: "sessiondate", width: "col-sm-2", dateType: "ontype", }),

    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),
    ...controls.displayText({ tab: "filter", label: "Member Type", width: "col-sm-2" }),
    {
      inputType: "select",
      default: "",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "Regular",
          value: "Regular"
        },
        {
          label: "Associated",
          value: "Associated"
        },
        {
          label: "Nominal(B Class)",
          value: "Nominal(B Class)"
        },

      ],
      placeHolder: "Member Type",
      name: "MemberType",
      description: "Enter Member Type"
    },

    ...controls.displayText({ tab: "filter", width: "col-sm-8" }),
    ...controls.displayText({ tab: "filter", label: "Selection", width: "col-sm-2" }),
    {
      inputType: "select",
      default: "",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "New Member",
          value: "New Member"
        },
        {
          label: "Additional Shares",
          value: "Additional Shares"
        },
        {
          label: "Share Withdraw",
          value: "Share Withdraw"
        },

      ],
      placeHolder: "Selection",
      name: "Selection",
      description: "Enter Selection"
    },



    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Share Demand Posting",
    clickable: false,
    extraRows: {
      fields: ["amount"],
      grandtotal: { type: "fixed", displayIn: "description", val: "Grand Total", count: true },
      // fixedTotals:[{by:"rows",rows:[1,2,3]}]
    },
    displayColumns: [
      {
        Header: "Srno",
        accessor: "srno",
        width: 150
      },
      {
        Header: "Date",
        accessor: "date",
        width: 150
      },
      {
        Header: "CIN",
        accessor: "cin",
        width: 150
      },
      {
        Header: "Member No",
        accessor: "member_no",
        width: 150
      },
      {
        Header: "Member Name",
        accessor: "full_name",
        width: 150
      },

      {
        Header: "No of Shares",
        accessor: "no_of_shares",
        width: 150
      },

      {
        Header: "Amount",
        accessor: "amount",
        width: 150
      },

      {
        Header: "Branch",
        accessor: "branch",
        width: 150
      },
      {
        Header: "Recno",
        accessor: "recno",
        width: 150
      },

    ]
  }
};

export default tr306;